import ApiClient from './ApiClient';

class AdminClient {
  constructor(authToken) {
    this.apiClient = new ApiClient(this.baseUri, this.params, this.headers);
    this.gatewayUri = 'api/v1';
    this.baseUri = process.env.VUE_APP_HACKATHON_SERVICE_URI;
    this.headers = {
      Authorization: `Bearer ${authToken}`,
    };
    this.params = {};
  }

  progressState(eventId) {
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${eventId}/progress`, this.params, this.headers)
      .then((response) => response.data);
  }

  getPeopleWhoHaveNotSetPrizePreferences(eventId) {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/events/${eventId}/admin/prizes/preferences`, this.params, this.headers)
      .then((response) => response.data);
  }

  getResults(eventId) {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/events/${eventId}/admin/results`, this.params, this.headers)
      .then((response) => response.data);
  }

  getScheduleOptions(eventId) {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/events/${eventId}/admin/schedule/options`, this.params, this.headers)
      .then((response) => response.data);
  }

  setPresentationTime(eventId, seconds) {
    const payload = {
      presentationTimeSeconds: seconds,
    };
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${eventId}/admin/schedule/options`, payload, this.headers)
      .then((response) => response.data);
  }

  updateEventDetails(eventId, notes) {
    const payload = {
      eventNotes: notes,
    };
    return this.apiClient.put(`${this.baseUri}${this.gatewayUri}/events/${eventId}/admin/details`, payload, this.headers)
      .then((response) => response.data);
  }

  updateScheduleOptions(eventId, options) {
    // honestly just spelling this out for a reference
    // all integer values
    // minimumPresentationSeconds
    // maximumPresentationSeconds
    // maximumTotalMinutes
    // presentationBufferSeconds
    // lunchMinutes
    // breaks
    // breakMinutes
    return this.apiClient.put(`${this.baseUri}${this.gatewayUri}/events/${eventId}/admin/schedule/options`, options, this.headers)
      .then((response) => response);
  }

  addAdmin(eventId, adminEmail) {
    const payload = {
      email: adminEmail,
    };
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${eventId}/admins`, payload, this.headers)
      .then((response) => response.data);
  }
}
export default AdminClient;
